import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, PhoneIcon, ArrowRightIcon } from 'lucide-react';
import { business } from '../data/business';
type ContactBandProps = {
  heading: string;
  text: string;
};
export function ContactBand({
  heading,
  text
}: ContactBandProps) {
  return <section className="border-t border-line bg-canvas" aria-labelledby="contactband-titel" data-id="element-20" data-mp="1gxvup75wl5fb">
      <div className="mx-auto max-w-shell px-6 py-16 md:py-20" data-id="element-21" data-mp="129r99vfgufsu">
        <div className="grid gap-10 lg:grid-cols-[1.2fr_1fr] lg:items-end" data-id="element-22" data-mp="127eicsrqcv3n">
          <div data-id="element-23" data-mp="171si17dfdoe4">
            <h2 id="contactband-titel" className="max-w-2xl font-display text-3xl font-700 leading-[1.1] tracking-tightest text-ink md:text-4xl" data-id="element-24" data-mp="171iudqfurtbl">
              {heading}
            </h2>
            <p className="mt-4 max-w-xl text-[17px] leading-relaxed text-ink-soft" data-id="element-25" data-mp="jan6h4eipi9m">{text}</p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row lg:justify-end" data-id="element-26" data-mp="o9gi0ra8uz75">
            <a href={`mailto:${business.email}?subject=Aanvraag%20gordijnrails`} className="inline-flex items-center justify-center gap-2 bg-accent px-6 py-4 text-[15px] font-semibold text-white transition-colors hover:bg-accent-dark" data-id="element-27" data-mp="obkiez8xpg2o">
              <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-28" data-mp="32a31yi0ob1p3" />
              Stuur een aanvraag
            </a>
            <a href={`tel:${business.phoneLink}`} className="inline-flex items-center justify-center gap-2 border border-ink px-6 py-4 text-[15px] font-semibold text-ink transition-colors hover:bg-ink hover:text-white" data-id="element-29" data-mp="2y76cc7cpu5bn">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-30" data-mp="2jcthqynixk6s" />
              {business.phoneDisplay}
            </a>
          </div>
        </div>
        <p className="mt-8 border-t border-line pt-6 text-[15px] text-ink-mute" data-id="element-31" data-mp="2ejgx0zlytxjb">
          Liever eerst de volledige contactgegevens en route bekijken?{' '}
          <Link to="/contact" className="font-semibold text-ink underline decoration-accent underline-offset-4" data-id="element-32" data-mp="1mtcdt49xzgjo">
            Ga naar onze contactpagina
            <ArrowRightIcon className="ml-1 inline h-4 w-4" aria-hidden="true" data-id="element-33" data-mp="3qxp1zoaxl1rl" />
          </Link>
        </p>
      </div>
    </section>;
}